module.exports = __webpack_public_path__ + "img/img_82837_0_47.b22d1e81.png";